import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { UserService } from 'src/app/shared/services/user.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
  selector: 'app-no-role',
  templateUrl: './no-role.component.html',
  styleUrls: ['./no-role.component.scss'],
  imports: [MatButtonModule, PageHeaderComponent, EmptyStateComponent],
})
export class NoRoleComponent {
  private readonly usrSvc = inject(UserService);
  private readonly userManagementSrv = inject(UserManagementService);

  logout() {
    this.usrSvc.logout();
  }
}
